// const BaseURL = window.location.origin
const BaseURL = process.env.NODE_ENV == 'development' ? 'http://192.168.2.50:9001': 'https://mqhb.bidanet.com'


export default BaseURL;
